import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { transparentize } from 'polished'

export const GridlinesMain = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  ${clamp('left', 22, 49, breakpoints.mobile, breakpoints.contained)}
  ${clamp('right', 22, 49, breakpoints.mobile, breakpoints.contained)}
  pointer-events: none;
  z-index: 1000;

  > [data-grid] {
    height: 100%;
  }
`

export const GridlinesColumn = styled.div`
  width: 100%;
  height: 100vh;
  background-color: ${transparentize(0.9, 'red')};
`